export default __webpack_public_path__ + "static/shopi2-ebda43a0791f0c475719b20225f8e6b1.jpg";